<div class="tables-container">
    <div *ngFor="let key of getObjectKeys(voucherData)" class="voucher-row">
        <table class="voucher-table debit-table">
            <thead>
                <tr>
                    <th colspan="3">Debit</th>
                </tr>
                <tr>
                    <th>Ledger Name</th>
                    <th>Amount</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ voucherData[key].dr.ledger_name?.ledger_name  || voucherData[key].dr.ledger_name }}</td>
                    <td>{{ voucherData[key].dr.amount }}</td>
                    <td>{{ voucherData[key].dr.description }}</td>
                </tr>
            </tbody>
        </table>
        <table class="voucher-table credit-table">
            <thead>
                <tr>
                    <th colspan="3">Credit</th>
                </tr>
                <tr>
                    <th>Ledger Name</th>
                    <th>Amount</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ voucherData[key].cr.ledger_name?.ledger_name || voucherData[key].cr.ledger_name }}</td>
                    <td>{{ voucherData[key].cr.amount }}</td>
                    <td>{{ voucherData[key].cr.description }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
